<template>
  <div class="box">
    <img src="../assets/icon/404.png" alt="" />
    <h3>{{ l.not_fount_h3 }}</h3>
    <div class="msg">
      {{ l.not_fount_cause }}:
      <div>{{ l.not_fount_cause1 }}</div>
      <div>{{ l.not_fount_cause2 }}</div>
      <div>{{ l.not_fount_cause3 }}</div>
    </div>
  </div>
</template>

<script>
import l from "../locales";
export default {
  data() {
    return {
      l: l.my
    };
  }
};
</script>

<style lang="less" scoped>
.box {
  width: 100vw;
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 85%;
    margin-bottom: 20px;
  }
  .msg {
    font-size: 12px;
    margin-top: 30px;
    font-weight: 600;
    div {
      line-height: 26px;
      font-weight: 400;
    }
  }
}
</style>
